import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { VoidUrl } from "@/common/types";
import { formatImageUrl } from "@/common/utils";
import { cmsHomeUrl } from "@/urls";
import { CompanyApiApi } from "@/apis/api/CompanyApiApi";
import { CompanyMembershipTypeEnum } from "@/apis/model/CompanyMembershipTypeEnum";
import { ImageSizeTypeEnum } from "@/apis/model/ImageSizeTypeEnum"; // eslint-disable-next-line fht-eslint-rules/string-literal-validator

var defaultCompanyLogoUrl = "https://img2.fht360.com/82/bf/13da66c4479b957cdf4462ffbac0.png@!origin";
var companyApi = new CompanyApiApi();

function getCompanyDetail(companyId) {
  return __awaiter(this, void 0, Promise, function () {
    var res;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , companyApi.companyApiGetCompany({
            companyId: companyId
          })];

        case 1:
          res = _a.sent();
          return [2
          /*return*/
          , res];
      }
    });
  });
}

var ContactCardCompanyInfo =
/** @class */
function (_super) {
  __extends(ContactCardCompanyInfo, _super);

  function ContactCardCompanyInfo(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      companyDetail: undefined
    };
    return _this;
  }

  ContactCardCompanyInfo.prototype.getCompanyDetailEffect = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , getCompanyDetail(this.props.companyId)];

          case 1:
            res = _a.sent();
            this.setState({
              companyDetail: res
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ContactCardCompanyInfo.prototype.componentDidMount = function () {
    this.getCompanyDetailEffect();
  };

  ContactCardCompanyInfo.prototype.componentDidUpdate = function (prevProps, prevState) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (prevProps.companyId !== this.props.companyId) {
          this.getCompanyDetailEffect();
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  ContactCardCompanyInfo.prototype.render = function () {
    var companyDetail = this.state.companyDetail;
    var cc = companyDetail && companyDetail.Company;
    return _jsx("div", {
      children: companyDetail && _jsxs("div", {
        children: [_jsxs("div", __assign({
          className: "chat-contact-info__company"
        }, {
          children: [_jsx("a", __assign({
            "data-companyid": cc.CompanyId,
            className: "chat-contact-info__avatar" + (cc && cc.NoShops ? " js-no-shop" : ""),
            href: VoidUrl,
            target: "_blank"
          }, {
            children: _jsx("img", {
              src: cc.LogoUrl && cc.LogoUrl.AbsoluteUrl ? formatImageUrl(cc.LogoUrl.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail200whFit) : defaultCompanyLogoUrl,
              alt: "\u516C\u53F8LOGO"
            }, void 0)
          }), void 0), cc.NoShops ? _jsx("a", __assign({
            href: VoidUrl,
            className: "chat-contact-info__company-name js-no-shop",
            "data-companyid": cc.CompanyId,
            target: "_blank"
          }, {
            children: cc.CompanyName
          }), void 0) : _jsxs("div", __assign({
            className: "chat-contact-info__company-info"
          }, {
            children: [_jsx("a", __assign({
              href: cmsHomeUrl(cc && cc.CompanyId, {
                stat_ctx: "ChatContact"
              }),
              className: "chat-contact-info__company-name",
              target: "_blank"
            }, {
              children: cc.CompanyName
            }), void 0), cc.IsCompanyVerified ? _jsx("img", {
              className: "chat-contact-info__verification-icon",
              src: formatImageUrl(cc && cc.CompanyVerifiedIco.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail44whFill)
            }, void 0) : undefined, cc.CompanyPackageType !== CompanyMembershipTypeEnum.None ? _jsx("img", {
              className: "chat-contact-info__membership-icon",
              src: formatImageUrl(cc && cc.CompanyPackageIco.AbsoluteUrl, ImageSizeTypeEnum.Thumbnail44whFill)
            }, void 0) : undefined]
          }), void 0)]
        }), void 0), _jsx("div", {
          children: _jsxs("ul", __assign({
            className: "chat-contact-info__info-items chat-contact-info__personal"
          }, {
            children: [companyDetail.CompanyContactInfo.RealName && _jsxs("li", __assign({
              className: "chat-contact-info__info-item"
            }, {
              children: [_jsx("span", __assign({
                className: "chat-contact-info__item-title"
              }, {
                children: "\u8054\u7CFB\u4EBA"
              }), void 0), _jsx("span", __assign({
                className: "chat-contact-info__item-value"
              }, {
                children: companyDetail.CompanyContactInfo.RealName
              }), void 0)]
            }), void 0), companyDetail.CompanyContactInfo.Mobile && _jsxs("li", __assign({
              className: "chat-contact-info__info-item"
            }, {
              children: [_jsx("span", __assign({
                className: "chat-contact-info__item-title"
              }, {
                children: "\u7535\xA0\xA0\xA0\u8BDD"
              }), void 0), _jsx("span", __assign({
                className: "chat-contact-info__item-value"
              }, {
                children: companyDetail.CompanyContactInfo.Mobile
              }), void 0)]
            }), void 0), _jsxs("li", __assign({
              className: "chat-contact-info__info-item"
            }, {
              children: [_jsx("span", __assign({
                className: "chat-contact-info__item-title"
              }, {
                children: "\u5730\xA0\xA0\xA0\u5740"
              }), void 0), _jsx("span", __assign({
                className: "chat-contact-info__item-value"
              }, {
                children: cc.Region.FirstLevel + " " + cc.Region.SecondLevel
              }), void 0)]
            }), void 0)]
          }), void 0)
        }, void 0)]
      }, void 0)
    }, void 0);
  };

  return ContactCardCompanyInfo;
}(React.Component);

export default ContactCardCompanyInfo;